import { GenericArrayServiceRequest } from '@nts/std';
import { MenuNodeIdentity } from '../domain-models/menu-node.identity';

export class GetChildrenFromNodeListRequest extends GenericArrayServiceRequest<MenuNodeIdentity> {

}
